<template>
    <navigation />

    <samples-list />

    <pricing />

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import Pricing from "../partials/Pricing.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import Samples from "../partials/Samples.vue";
import SamplesList from "../partials/SamplesList.vue";

export default {
    name: "Samples",

    components: {
      SamplesList,
      Navigation,
      Pricing,
      SiteFooter,
      Samples,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("samples.title")}`,
        };
    },
};
</script>
